var render = function render(_c,_vm){return _c('div',{class:['site-loading', { active: _vm.props.activated }],staticStyle:{"z-index":"100"}},[_vm._m(0)])
}
var staticRenderFns = [function (_c,_vm){return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"circle"})])
}]

export { render, staticRenderFns }